"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PieProgressbar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Flex_1 = require("./Flex");
const Text_1 = require("./Text");
const constants_1 = require("../constants");
const PieSlice = styled_1.default.div `
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: conic-gradient(
    ${constants_1.Color.BLUE} ${(props) => props.percentage}%,
    ${constants_1.Color.MEDIUM_GREY} 0
  );
`;
const PieProgressbar = ({ percentage, label, }) => {
    return ((0, jsx_runtime_1.jsxs)(Flex_1.Flex, { styles: {
            alignItems: 'center',
            justifyContent: 'space-between',
            width: label ? undefined : 58,
        }, children: [(0, jsx_runtime_1.jsx)(Flex_1.Flex, { styles: {
                    width: 20,
                    height: 20,
                }, children: (0, jsx_runtime_1.jsx)(PieSlice, { percentage: percentage }) }), (0, jsx_runtime_1.jsxs)(Text_1.Text, { fontSize: 13, fontWeight: constants_1.theme.font.weight.legacy[600], pl: label ? 1 : undefined, children: [percentage.toFixed(0), "%", label ? ` ${label}` : ''] })] }));
};
exports.PieProgressbar = PieProgressbar;
